/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  /*
    Observe whether or not there are open modals that require scroll lock
  */

  function hasOpenModals() {
    const openModals = Boolean(document.querySelectorAll('dialog[open][data-scroll-lock-required]').length);
    const openDrawers = Boolean(document.querySelectorAll('.drawer.is-open').length);

    return openModals || openDrawers;
  }

  function focusable(container) {
    var elements = Array.prototype.slice.call(
      container.querySelectorAll('[tabindex],' + '[draggable],' + 'a[href],' + 'area,' + 'button:enabled,' + 'input:not([type=hidden]):enabled,' + 'object,' + 'select:enabled,' + 'textarea:enabled')
    );

    // Filter out elements that are not visible.
    // Copied from jQuery https://github.com/jquery/jquery/blob/2d4f53416e5f74fa98e0c1d66b6f3c285a12f0ce/src/css/hiddenVisibleSelectors.js
    return elements.filter(function (element) {
      return !!((element.offsetWidth || element.offsetHeight || element.getClientRects().length) && isVisible(element));
    });
  }

  function isVisible(el) {
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  /**
   * Moves focus to an HTML element
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects. Used in bindInPageLinks()
   * eg move focus to a modal that is opened. Used in trapFocus()
   *
   * @param {Element} container - Container DOM element to trap focus inside of
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   */
  function forceFocus(element, options) {
    options = options || {};

    var savedTabIndex = element.tabIndex;

    element.tabIndex = -1;
    element.dataset.tabIndex = savedTabIndex;
    element.focus();
    if (typeof options.className !== 'undefined') {
      element.classList.add(options.className);
    }
    element.addEventListener('blur', callback);

    function callback(event) {
      event.target.removeEventListener(event.type, callback);

      element.tabIndex = savedTabIndex;
      delete element.dataset.tabIndex;
      if (typeof options.className !== 'undefined') {
        element.classList.remove(options.className);
      }
    }
  }

  /**
   * Traps the focus in a particular container
   *
   * @param {Element} container - Container DOM element to trap focus inside of
   * @param {Element} elementToFocus - Element to be focused on first
   * @param {Object} options - Settings unique to your theme
   * @param {string} options.className - Class name to apply to element on focus.
   */

  var trapFocusHandlers = {};

  function trapFocus(container, options) {
    options = options || {};
    var elements = focusable(container);
    var elementToFocus = options.elementToFocus || container;
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = function (event) {
      if (container !== event.target && !container.contains(event.target) && first && first === event.target) {
        first.focus();
      }

      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
      if (event.code !== 'Tab') return; // If not TAB key

      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    forceFocus(elementToFocus, options);
  }

  /**
   * Removes the trap of focus from the page
   */
  function removeTrapFocus() {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  }

  /**
   * Auto focus the last element
   */
  function autoFocusLastElement() {
    if (window.a11y.lastElement && document.body.classList.contains('is-focused')) {
      setTimeout(() => {
        window.a11y.lastElement?.focus();
      });
    }
  }

  var a11y = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    forceFocus: forceFocus,
    trapFocus: trapFocus,
    removeTrapFocus: removeTrapFocus,
    autoFocusLastElement: autoFocusLastElement
  });

  /*
    Trigger event after animation completes
  */
  function waitForAnimationEnd(element) {
    return new Promise((resolve) => {
      function onAnimationEnd(event) {
        if (event.target != element) return;

        element.removeEventListener('animationend', onAnimationEnd);
        resolve();
      }

      element?.addEventListener('animationend', onAnimationEnd);
    });
  }
  const selectors$a = {
    open: '[data-popup-open]',
    close: '[data-popup-close]',
    focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
  };
  const attributes$7 = {
    closing: 'closing',
  };
  class PopupActions {
    constructor(popup, holder, showModal = true, scrollLock = true) {
      this.popup = popup;
      this.holder = holder;
      this.a11y = a11y;
      this.isAnimating = false;
      this.showModal = showModal;
      this.enableScrollLock = scrollLock;
      this.buttonPopupOpen = this.holder?.querySelector(selectors$a.open);

      this.popupEvents();
    }

    popupOpen() {
      if (!this.popup) return;

      this.isAnimating = true;

      // Check if browser supports Dialog tags
      if (this.showModal && typeof this.popup.showModal === 'function') {
        this.popup.showModal();
      } else if (!this.showModal && typeof this.popup.show === 'function') {
        this.popup.show();
      } else {
        this.popup.setAttribute('open', '');
      }

      this.popup.removeAttribute('inert');
      this.popup.setAttribute('aria-hidden', false);
      this.popup.focus(); // Focus <dialog> tag element to prevent immediate closing on Escape keypress

      if (this.enableScrollLock) {
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
      }

      waitForAnimationEnd(this.popup).then(() => {
        this.isAnimating = false;

        if (this.enableScrollLock) {
          this.a11y.trapFocus(this.popup);
        }

        const focusTarget = this.popup.querySelector('[autofocus]') || this.popup.querySelector(selectors$a.focusable);
        focusTarget?.focus();
      });
    }

    popupClose() {
      if (this.isAnimating || !this.popup || this.popup.hasAttribute('inert')) {
        return;
      }

      if (!this.popup.hasAttribute(attributes$7.closing)) {
        this.popup.setAttribute(attributes$7.closing, '');
        this.isAnimating = true;

        waitForAnimationEnd(this.popup).then(() => {
          this.isAnimating = false;
          this.popupClose();
        });

        return;
      }

      // Check if browser supports Dialog tags
      if (typeof this.popup.close === 'function') {
        this.popup.close();
      } else {
        this.popup.removeAttribute('open');
        this.popup.setAttribute('aria-hidden', true);
      }

      this.popupCloseActions();
    }

    popupCloseActions() {
      if (this.popup.hasAttribute('inert')) return;

      this.popup.setAttribute('inert', '');
      this.popup.setAttribute('aria-hidden', true);
      this.popup.removeAttribute(attributes$7.closing);

      // Unlock scroll if no other popups & modals are open
      if (!hasOpenModals() && this.enableScrollLock) {
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
      }

      this.popup.dispatchEvent(new CustomEvent('theme:popup:onclose', {bubbles: false}));

      if (this.enableScrollLock) {
        this.a11y.removeTrapFocus();
        this.a11y.autoFocusLastElement();
      }
    }

    popupEvents() {
      if (!this.popup) return;

      // Open button click event
      this.buttonPopupOpen?.addEventListener('click', (e) => {
        e.preventDefault();
        this.popupOpen();
        window.a11y.lastElement = this.buttonPopupOpen;
      });

      // Close button click event
      const closeButtons = this.popup.querySelectorAll(selectors$a.close);
      if (closeButtons.length) {
        closeButtons.forEach((closeButton) => {
          closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.popupClose();
          });
        });
      }

      // Close dialog on click outside content
      if (this.showModal) {
        this.popup.addEventListener('click', (event) => {
          if (event.target.nodeName === 'DIALOG' && event.type === 'click') {
            this.popupClose();
          }
        });
      }

      // Close dialog on click ESC key pressed
      this.popup.addEventListener('keydown', (event) => {
        if (event.code === 'Escape') {
          event.preventDefault();
          this.popupClose();
        }
      });

      this.popup.addEventListener('close', () => this.popupCloseActions());
    }
  }

  class ModalContent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      new PopupActions(this.querySelector('dialog'), this, true, true);
    }
  }

  class RsQuickAddProduct extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.RS_WAITLIST_MODAL_OPEN_EVENT = 'rsWaitlistModal:open';
      this.sizeSelectors = [...this.querySelectorAll('.size')];
      this.variantsJson = this.querySelector('.variants-json');
      this.variants = [];
      this.product = {};
      if (this.variantsJson && this.variantsJson.innerText) {
        this.variants = JSON.parse(this.variantsJson.innerText)?.variants;
        this.product = JSON.parse(this.variantsJson.innerText)?.product;
      }
      this.sizeSelectors.forEach((sizeSelector) => {
        sizeSelector.addEventListener('click', this.handleSizeSelectorClick.bind(this));
      });
      this.checkAvailability();
    }

    checkAvailability() {
      this.variants.forEach((variant, idx) => {
        if(!variant.available) {
          this.sizeSelectors[idx].classList.add('soldout');
        }
      });
    }

    async handleSizeSelectorClick(event) {
      event.preventDefault();
      event.stopPropagation();
      
      const sizeSelector = event.currentTarget;
      let variant = this.getVariantBySize(sizeSelector.dataset.value);

      if (event.currentTarget.classList.contains('soldout')) {
        document.dispatchEvent(
          new CustomEvent(this.RS_WAITLIST_MODAL_OPEN_EVENT, {
            bubbles: true,
            detail: {
              "productTitle": this.product?.title,
              "productId": this.product?.id,
              "variantId": variant?.id,
              "variantTitle": variant?.title
            }
          })
        );
      } else {
        await this.addToCart(variant?.id, event?.target);
      }
    }

    getVariantBySize(size) {
      let variant = this.variants.find((variant) => {
        if (variant.option_1 === size || variant.option_2 === size || variant.option_3 === size) {
          return variant;
        }
      });
      return variant;
    }

    async addToCart(variantId) {
      try {
        const response = await fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            "Content-Type": "application/json",
            "Accept": "application/javascript"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        const data = await response.json();

        if (response.ok) {
          document.dispatchEvent(
            new CustomEvent('theme:cart:refresh', {
              bubbles: true,
            })
          );

        } else {
          this.handleCartError(data);
        }
      } catch (error) {
        console.log("****** |Error Adding to cart:", error)
        this.handleCartError({ message: "Error Adding to Cart", description: "Please try again" });
      }
    }
    handleCartError(data) {
      const errorContainer = document.querySelector(`[data-cart-errors-container="${this.id}"]`);
      if (errorContainer) {
        let errorMessage = `${data.message}: ${data.description}`;

        if (data.message == data.description) {
          errorMessage = data.message;
        }

        errorContainer.innerHTML = `<div class="errors form-errors">${errorMessage}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`;
        errorContainer.classList.add('is-visible');
        this.formErrorsEvents(errorContainer);
      }
    }
    formErrorsEvents(errorContainer) {
      const buttonErrorClose = errorContainer.querySelector('[data-close-error]');
      buttonErrorClose?.addEventListener('click', (e) => {
        e.preventDefault();

        if (errorContainer) {
          errorContainer.classList.remove('is-visible');
        }
      });
    } 
  }

  class RsWaitListModal extends HTMLElement {
    constructor() {
      super();
      this.BIS_SUBMISSION_EVENT = 'klaviyo:bisSubmission';
      this.RS_WAITLIST_MODAL_OPEN_EVENT = 'rsWaitlistModal:open';
      this.HIDDEN_CLASS = 'hidden';

      this.waitlistModalOverlay = document.querySelector('.waitlist-modal-overlay');
      this.closeButton = this.querySelector('.waitlist-modal-close');
      this.closeLink = this.querySelector('.waitlist-modal-close-text');
      this.productTitleElement = this.querySelector('.waitlist-modal-title');
      this.productIdElement = this.querySelector("rs-wait-list-modal input[type='hidden'][name='product']");
      this.variantTitleElement = this.querySelector(".waitlist-modal-variant-title");
      this.variantIdElement = this.querySelector("rs-wait-list-modal input[type='hidden'][name='variant']");
      this.form = this.querySelector('form');
      this.apiVersion = this.dataset.apiVersion || '2024-07-15';
      this.companyId = this.dataset.companyId;
      this.successMessage = this.querySelector(".success-message");
      this.errorMessage = this.querySelector(".error-message");

      document.addEventListener(this.RS_WAITLIST_MODAL_OPEN_EVENT, this.openModal.bind(this));

      this?.waitlistModalOverlay?.addEventListener('click', this.closeModal.bind(this));
      this?.closeButton?.addEventListener('click', this.closeModal.bind(this));
      this?.closeLink?.addEventListener('click', this.closeModal.bind(this));
      this?.form?.addEventListener('submit', this.handleSubmit.bind(this));
      document.addEventListener(this.BIS_SUBMISSION_EVENT, this.handleBisSubmissionResp.bind(this));
    }
    connectedCallback() {
    }
    openModal(event) {
      this.updateContent(event.detail);

      this.waitlistModalOverlay.classList.add('is-open');
      this.classList.add('is-open');
    }
    closeModal() {
      this.waitlistModalOverlay.classList.remove('is-open');
      this.classList.remove('is-open');
      this.successMessage?.classList?.add(this.HIDDEN_CLASS);
      this.errorMessage?.classList?.add(this.HIDDEN_CLASS); 
    }
    updateContent(detail) {
      this.productTitle = detail?.productTitle;
      this.productId = detail?.productId;
      this.variantTitle = detail?.variantTitle;
      this.variantId = detail?.variantId;

      if (this.productTitleElement) {
        this.productTitleElement.innerText = this.productTitle;
      }
      if (this.productIdElement) {
        this.productIdElement.value = this.productId;
      }
      if (this.variantTitleElement) {
        this.variantTitleElement.innerText = this.variantTitle;
      }
      if (this.variantIdElement) {
        this.variantIdElement.value = this.variantId;
      }
    }
    async handleSubmit(e) {
      e.preventDefault();
      const formData = new FormData(this.form);
      const variantId = formData.get('variant');
      const email = formData.get('email');

      if (!variantId || !this.companyId || !this.apiVersion) {
        console.log("Missing params");
      } else if (!email) {
        console.log("Email required");
      } else {
        const data = {
          email,
          variantId,
          companyId: this.companyId,
          apiVersion: this.apiVersion
        };

        // Submit the back in stock
        const resp = await this.submitBIS(data);
      }
    }
    async submitBIS(data) {
      const resp = {};
      if (!data) {
        resp.ok = false;
        resp.errorData = {
          message: 'Missing data'
        }
      } else {
        const body = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: data.email
                  }
                }
              },
              "channels": ["EMAIL"],
            },
            relationships: { 
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${data.variantId}`
                }
              }
            }
          }
        };

        const headers = {
          revision: data.apiVersion,
          'content-type': 'application/json'
        }
        const options = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(body)
        };
        const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${data.companyId}`;

        const payload = {
          detail: {
            target: this
          }
        };

        try {
          const response = await fetch(url,options);
          payload.detail.response = response;

          if (response?.ok) {
            payload.detail.success = true;
          } else {
            payload.detail.success = false;
          }
        } catch (error) {
          console.log("****** | RsKlaviyoBis | submitBIS | error:", error);
          payload.detail.success = false;
        }

        if (payload.detail.success) {
          resp.ok = true;
        } else {
          resp.ok = false;
          resp.errorData = {
            message: 'Error submitting Klaviyo back in stock.'
          }
        }

        const event = new CustomEvent(this.BIS_SUBMISSION_EVENT, payload);
        document.dispatchEvent(event);
      }

      return resp;
    }

    handleBisSubmissionResp(e) {
      const target = e?.detail?.target;
      const response = e?.detail?.response;

      if (target && response) {
        this.successMessage?.classList?.add(this.HIDDEN_CLASS);
        this.errorMessage?.classList?.add(this.HIDDEN_CLASS); 

        if (response?.ok) {
          this.successMessage?.classList?.remove(this.HIDDEN_CLASS);
        } else {
          if(this.errorMessage) {
            this.errorMessage.innerText = 'Error submitting Klaviyo back in stock.';
            this.errorMessage.classList.remove(this.HIDDEN_CLASS);
          }
        }
      }
    }
  }

  if (!customElements.get('modal-content')) {
    customElements.define('modal-content', ModalContent);
  }

  if (!customElements.get('rs-quick-add-product')) {
    customElements.define('rs-quick-add-product', RsQuickAddProduct);
  }

  if (!customElements.get('rs-wait-list-modal')) {
    customElements.define('rs-wait-list-modal', RsWaitListModal);
  }

  // Header points dropdown
  const yotpoPoints = document.getElementById('yotpo-points');
  const pointsDrownContainer = document.getElementById('points-dropdown-container');
  yotpoPoints?.addEventListener('click', (e) => {
    pointsDrownContainer.classList.remove('hidden');
  });
  document.addEventListener('click', (e) => {
    if(!e?.target?.closest('#yotpo-points') && !e?.target?.closest('#points-dropdown-container')) {
      pointsDrownContainer?.classList.add('hidden');
    }
  });

  const removeShippingProtection = async () => {
    try {
      console.log("LABL Custom")
      const response = await fetch("/cart.js");

      if(response.ok){
        const cart = await response.json();

        const lablItems = cart?.items?.filter((i)=>i.vendor?.toLowerCase().includes("lablpx"));

        if (lablItems?.length) {
          await Promise.all(
            lablItems.map((item) =>
              fetch("/cart/change.js", {
                method: "POST",
                 headers: {
                  "X-Requested-With": "XMLHttpRequest",
                  "Content-Type": "application/json",
                  "Accept": "application/javascript"
                },
                body: JSON.stringify({
                  quantity: 0,
                  id: item.id.toString(),
                }),
              })
            )
          );

          document.dispatchEvent(
            new CustomEvent('theme:cart:refresh', {
              bubbles: false,
            })
          );
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
  setTimeout(()=>{
    removeShippingProtection();
  },1000)

  class TruncateText extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: "open" });
      this.shadowRoot.innerHTML = `
        <style>
          .container {
            position: relative;
          }
          .text {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 1.5;
            overflow: hidden;
          }
          .text.expanded {
            -webkit-line-clamp: unset;
          }
          .button {
            cursor: pointer;
            color: var(--text);
            border: none;
            background: none;
            padding: 0;
            font-size: 16px;
            text-decoration: underline;
            text-underline-offset: 4px;
            margin-top: 0.5em;
          }
        </style>
        <div class="container">
          <p class="text"><slot></slot></p>
          <button class="button">Read more</button>
        </div>
      `;
      this.textElement = this.shadowRoot.querySelector(".text");
      this.buttonElement = this.shadowRoot.querySelector(".button");
      this.buttonElement.addEventListener("click", () => this.toggleText());
    }
    toggleText() {
      const expanded = this.textElement.classList.toggle("expanded");
      this.buttonElement.textContent = expanded ? "Read less" : "Read more";
    }
  }

  if (!customElements.get('truncate-text')) {
    customElements.define("truncate-text", TruncateText);
  }

  // Rewrap Badge Functionality
  // Watch for .r-app-content-loaded to have content and add rewrap badges to .r-pdp-image elements
  function addRewrapBadges() {
    const appContentContainer = document.querySelector('.r-app-content-loaded');
    
    if (!appContentContainer) {
      return;
    }

    // Check if container has meaningful content (not just whitespace)
    const hasContent = appContentContainer.children.length > 0 || 
                      (appContentContainer.textContent && appContentContainer.textContent.trim().length > 0);
    
    if (hasContent) {
      const pdpDesktopImage = document.querySelector('.r-pdp-images-desktop .r-pdp-image');
      if (pdpDesktopImage) {
        addRewrapBadgesToPdpImages(pdpDesktopImage);
      }
      const pdpMobileImage = document.querySelector('.r-pdp-mobile-image .r-pdp-image');
      if (pdpMobileImage) {
        addRewrapBadgesToPdpImages(pdpMobileImage);
      }
    }
  }

  function addRewrapBadgesToPdpImages(imageElement) {
    // Check if badge already exists to avoid duplicates
    if (imageElement.querySelector('.rewrap-badge')) {
      return;
    }
    
    // Create rewrap badge element
    const rewrapBadge = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    rewrapBadge.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    rewrapBadge.setAttribute('viewBox', '0 0 195.63 129.89');
    rewrapBadge.setAttribute('class', 'rewrap-badge icon icon-rewrap');
    rewrapBadge.setAttribute('style', '--icon-size: 75px;');
    rewrapBadge.innerHTML = `
      <defs>
        <style>
          .cls-1, .cls-2, .cls-3 {
            fill-rule: evenodd !important;
          }

          .cls-1, .cls-2, .cls-3, .cls-4 {
            fill: #ba2a6f !important;
            stroke: #bb296e !important;
          }

          .cls-1, .cls-5, .cls-4 {
            stroke-miterlimit: 10 !important;
          }

          .cls-1, .cls-4 {
            stroke-width: .63px !important;
          }

          .cls-2 {
            stroke-width: .76px !important;
          }

          .cls-3 {
            stroke-width: 1.3px !important;
          }

          .cls-5 {
            fill: #010101 !important;
            stroke: #010101 !important;
          }
        </style>
      </defs>
      <g>
        <path class="cls-5" d="M36.43,8.43c2.76,0,5.32.44,7.69,1.32,2.37.88,4.43,2.2,6.16,3.96,1.74,1.76,3.09,3.96,4.07,6.61.98,2.64,1.47,5.74,1.47,9.31,0,3.12-.4,6.01-1.2,8.65-.8,2.64-2.01,4.92-3.62,6.85-1.61,1.92-3.63,3.43-6.05,4.53-2.41,1.1-5.26,1.65-8.53,1.65h-18.43V8.43h18.43ZM35.77,43.38c1.36,0,2.67-.22,3.95-.66,1.28-.44,2.41-1.17,3.41-2.19,1-1.02,1.8-2.35,2.4-3.99.6-1.64.9-3.64.9-6,0-2.16-.21-4.11-.63-5.85-.42-1.74-1.11-3.23-2.07-4.47-.96-1.24-2.22-2.19-3.8-2.85-1.58-.66-3.52-.99-5.83-.99h-6.71v27.02h8.38Z"></path>
        <polygon class="cls-5" points="84.58 8.43 74.94 38.58 74.82 38.58 65.3 8.43 55.67 8.43 69.49 51.31 80.09 51.31 94.27 8.43 84.58 8.43"></polygon>
        <polygon class="cls-5" points="99 8.43 99 51.28 108.39 51.28 108.39 33.58 126.27 33.58 126.27 26.26 108.39 26.26 108.39 16.36 129.03 16.36 129.03 8.43 99 8.43"></polygon>
      </g>
      <g>
        <path class="cls-4" d="M69.28,36.6c-.72-1.25-4.24-3.12-8.47-2.82-.8.06-2.79.31-4.11,1.43-2.19,1.87-2.98,4.73-3.47,7.28-.65,3.42-.72,6.85-.7,10.04.02,2.34-.15,4.74-.31,7.07l-.12,1.7c-.29,4.52-1.06,9.13-1.8,13.59-.49,2.92-.99,5.93-1.35,8.91-.02.14-.03.31-.04.5-.02.29-.04.64-.1.96l-6.84-36.26c.04-.08.08-.15.13-.21.12-.15.24-.27.35-.39.35-.36.7-.73.8-1.43.14-1.08-.84-8.33-2.44-10.16-.46-.53-1.02-.66-1.53-.36-1.6.93-1.6,4.07-1.61,5.57,0,0,0,.2,0,.2-.03,5.85,1.67,11.85,2.81,17.55,1.8,9.1,2.33,18.22,3.54,27.38.35,2.67.75,10.12,4.64,10.12,1.82,0,2.14-2.06,2.27-2.94.26-1.7.71-3.47,1.15-5.18.36-1.39.72-2.83,1-4.24.66-3.47,1.06-6.97,1.38-9.98.11-1.01.22-2.02.33-3.03.38-3.44.77-6.99,1-10.49.16-2.39.26-4.82.35-7.16.14-3.55.29-7.23.65-10.84.1-.97.47-3.35,1.9-4.42,1.26-.94,2.99-1.4,5.29-1.4,1.41,0,2.8.18,3.72.31.21.03.4.05.56.05.52,0,.87-.15,1.04-.45.09-.15.2-.47-.06-.9Z"></path>
        <path class="cls-1" d="M75.54,59.91c-.62.31-1.29-.19-1.82-.47-.34-.18-1.24-.58-1.36-.98-.06-.22.07-.47.06-.7,0-.26-.1-.51-.18-.75-.14-.44-.29-.86-.05-1.29.54-.96,1.52-.6,2.21-.05.86.69,1.5,1.79,1.71,2.87.1.51-.07,1.12-.56,1.37Z"></path>
        <path class="cls-1" d="M90.47,79.91c.39-.89.85-5.02-1.13-4.39-.85.27-1.07,1.19-1.28,1.95-.32,1.09-.75,2.15-1.18,3.2-.38.93-1,1.71-1.6,2.51-.68.91-1.37,1.83-2.15,2.66-.74.79-2,2.18-3.21,1.55-.71-.37-1.35-1.33-1.67-2.04-1-2.21-1.62-7.15-2.18-10.55-.32-1.92-.55-3.69-1.01-5.86-.24-1.11-.36-2.26-.82-3.31-.17-.4-.37-.91-.74-1.17-.37-.26-1.15-.24-1.53-.02-.57.33-.31,1.87-.31,2.43,0,.95.03,1.91.04,2.86.02,2.06,0,4.12-.27,6.16-.15,1.1-.37,2.21-.72,3.26-.28.85-1.1,2.85-1.51,3.52-.64,1.06-1.63,1.7-2.88,1.65-1.06-.04-2.41-.77-3.07-1.6-.37-.46-.95-1.39-1.65-.88-.59.43-.66,1.18-.49,1.83.19.73.6,1.15,1.1,1.68.39.42.82.8,1.28,1.13.94.67,2.05,1.16,3.21,1.3.68.08,1.51.1,2.18-.07,1.29-.33,2.1-1.6,2.72-2.67.75-1.29,1.24-2.7,1.7-4.12.13-.41.26-.82.39-1.23.09-.28.44-.93.38-1.22.6,3,.93,6.04,2.28,8.82.43.89.92,1.82,1.57,2.57,3.2,3.67,7.32-.63,9.38-3.52,1.47-2.07,2.4-4.19,3.17-6.35v-.09Z"></path>
        <path class="cls-1" d="M106.75,83.85v-.03c-.31-2.2-1.13-6.27-1.14-6.74-.04-2.26.19-4.36-.14-6.36-.22-1.33-.68-3.63-2.27-3.97-1.74-.37-2.44,1.82-3.07,3-1.17,2.2-2.07,4.45-2.96,6.78-.43,1.12-.75,2.38-1.52,3.18.08-1.56-.18-3.41-.55-5.53-.22-1.25-.37-2.52-.75-3.74-.29-.92-.92-2.07-1.95-2.28-.28-.06-.55,0-.8.12-.42.22-.78.54-.98.98-.2.43-.3.91-.41,1.38-.07.31-.14.61-.22.92-1.27,4.75-2.81,9.5-5.26,12.86-.16.22-.31.45-.48.66-.16.19-.35.36-.48.57-.24.39-.44.81-.58,1.25-.21.69-.1,1.65.8,1.73.22.02.49,0,.7-.07.28-.09.59-.27.78-.49.37-.42.71-.87,1.06-1.3,2.54-3.09,4.38-7.64,5.53-11.06.3,2.14.28,4.32.2,6.48-.04,1.05-.11,2.11-.18,3.16-.04.63-.42,2.1-.04,2.64.56.82,2.42,1.11,3.2.58.36-.24.65-1.32.97-1.94,1.08-2.06,2-4.12,2.77-6.08,1.27-3.23,2.01-6.28,3.32-8.44.25,2.64-.04,6.54.41,8.71.29,1.38.62,1.82,1.25,2.63.56.72,1.25,1.49,2.15,1.71.18,0,.7-.08.65-1.31Z"></path>
        <path class="cls-4" d="M138.35,45.27c-.8-.84-2.03-1.25-3.08-1.68-1.52-.62-3.29-1.37-4.78-1.65-3.24-.61-6.33-.24-8.44-.1.24-1.62.52-3.24.6-4.7.06-1.02.22-2.54-.4-3.43-1.55-2.21-2.62,2.03-2.83,2.92-.52,2.32-1.04,4.8-1.32,6.58-.87.31-2.12.72-3.34,1.26-1.08.48-2.61.99-3.22,1.57-.94.91-1.59,3.52.32,4.17.01,0,.02,0,.03,0,.29.08.76.08,1.18-.36,1.06-1.29,2.75-2.76,4.2-2.99,0,0-.61,4.46-.91,6.49-.29,2.14-.9,4.37-1.27,6.55-.38,2.17-.76,4.34-1.22,6.49-.63,2.94-1.29,5.99-2.61,8.71-1.04,2.14-1.82,4.57-4,5.84-.61.35-1.32.61-1.75,1.21-.5.7-.16,2.01.42,2.53,2.36,2.13,4.59-1.02,5.64-2.92.44-.8.82-1.62,1.21-2.44.66-1.39,1.26-2.83,1.73-4.3.23-.71.32-1.46.52-2.18.1-.37.23-.73.41-1.07.04-.07.55-.72.53-.76.45,1.24.19,2.91.34,4.22.1.86.18,1.74.36,2.59.19.93.55,2.26,1.42,2.79,1.69,1.02,2.36-1.03,2.58-2.27.2-1.19.41-2.39.49-3.59.17-2.45-.02-4.96-.27-7.4-.37-3.59-1.04-7.08-.69-10.69.27-2.76.63-5.5,1.04-8.24.09-.62.23-1.23.3-1.85.04-.33.19-.56.37-.74.02-.01.04-.02.06-.03.27-.22.57-.28.57-.28,2.47-1.14,5.37-.99,7.98-.42,1.5.32,2.93.81,4.35,1.36.75.3,2.66,1.75,3.47,1.48.29-.09.47-.26.57-.47.33-.67-.17-1.77-.58-2.21Z"></path>
        <path class="cls-3" d="M143.87,72.03c-.42.11-.72.32-.96.56-.3.3-.51.66-.72,1-.21.31-.88,1.58-1.56,1.47-.27-.04-.56-1.11-.61-1.29-.13-.5-.14-1.02-.16-1.53-.04-1.2-.15-2.4-.15-3.61,0-2.29.1-4.57.23-6.86.03-.48.07-.96.09-1.43,0-.18.04-.37.08-.55.13-.91-.18-1.36-.18-1.36-1.11-1.22-1.67-.85-1.77-.76-.14.33-.16.74-.18,1-.09.9.05,2.02-.56,2.85-.61-.44-1.7-.83-2.52-1.01-.79-.17-1.59-.11-2.31.18-.83.34-1.47.9-2.01,1.46-.68.71-1.24,1.48-1.73,2.27-.56.89-1.02,1.82-1.38,2.76-.37.98-.63,1.99-.8,3-.17,1-.25,2.02-.3,3.03-.04.95-.07,1.9.06,2.84.1.73.3,1.5.92,2.11.54.53,1.35.81,2.19,1.01,1.08.27,1.86-.64,2.38-1.16.7-.7,1.36-1.39,1.87-2.17,1.14-1.72,1.99-3.51,2.82-5.31.24-.52.48-1.05.72-1.57.12-.25.24-.51.37-.76.09-.17.4-.56.37-.74.57,2.99-.16,6.06.93,9,.16.42.76,2.04,1.63,2,.55-.02.99-.59,1.26-.88.44-.47.8-.98,1.13-1.5.32-.51.6-1.03.85-1.55.25-.51.66-1.1.77-1.64.1-.45.07-1.11-.76-.89ZM129.1,77.26c-2.71-2.42,1.27-18.4,7.86-13.66-1.5,5.67-3.75,10.59-7.86,13.66Z"></path>
        <path class="cls-2" d="M169.95,61.91c-.13.66-.35,1.31-.56,1.95-.11.33-.21.65-.29.98-.43,1.71-1.05,3.37-1.83,4.96-1.48,3.02-3.47,5.81-5.74,8.29-1.21,1.32-2.52,2.57-3.88,3.75.97-7.33.56-13.37.25-19.41-.13-2.5,1.18-7.92-1.85-9.24-.7-.31-2.59,9.05-2.73,9.8-.55,2.9-1.09,6.66-2.91,9.08-.78,1.04-2.22,1.95-3.55,2.07.98-1.99,4-4.41,4.85-8.52.46-2.25.52-5.31.07-7.53-.83-4.12-3.75-1.1-4.89,1.14-1.1,2.16-1.81,4.49-2.42,6.83-.18.68-.34,1.37-.42,2.07-.09.87-.1,1.74-.16,2.61-.08,1.24-.17,2.69.28,3.88,3.85,8.07,10.49-4.29,11.52-9.84.81,6.36.35,13.14-.32,20.05-3.94,4.96-12.65,9.88-15.56,17.35-2.59,6.63,1.87,13.93,5.8,17.5,3.34,3.04,7.93,2.72,9.21-1.23,1.52-4.68,1.85-13.81,1.92-19.87.05-3.9.04-11.46,1.16-13.15,4.05-6.1,9.98-10.92,12.5-17.97.48-1.34.42-3.05.6-4.48.12-.9-.93-1.64-1.05-1.05ZM149.29,60.13c1.01,2.93-.09,9-2.72,9.74.25-4.07,1.39-7.01,2.72-9.74ZM153.69,111.18c-.2,2.04-.05,5.41-1.48,7.02-2.39,2.72-6.71-1.69-8.06-3.52-1.26-1.71-2.47-4.06-2.8-6.19-1.49-9.65,9.8-15.17,13.65-20.49.28-.03.29.16.28.36-.52,7.06-.88,15.5-1.6,22.82Z"></path>
        <path class="cls-1" d="M173.67,69.16s2.28,2.78,2.49,3.02c.88.97,1.81,1.86,2.83,2.69,2.14,1.76,4.56,2.78,7.23,3.44.88.22,1.76.25,2.67.25.33,0,1.67-.1,1.43.55-.24.67-1.77.91-2.37,1.07-1.05.28-2.14.4-3.22.39-2.29-.03-4.27-.74-5.79-1.5-3.18-1.6-6.23-4.09-8.35-6.88-1.16-1.53-2.02-3.32-2.46-5.57-.9-4.6.4-8.89,2.38-13.01.56-1.16,1.14-2.3,1.65-3.48.29-.65.91-1.89,1.64-2.13,1.11-.36,2.88.16,3.51.66.57.45,1.07,1.64,1.37,2.42,1.1,2.8,1.03,6.76.4,9.34-.97,3.95-2.83,6.86-5.42,8.73ZM172,63.8c2.5-.93,3.47-3.61,3.59-6.83.05-1.23.43-3.96-1.24-3.44-1.49,2.85-2.2,6.33-2.36,10.27Z"></path>
      </g>
    `;
    
    // Position the badge relative to the image container
    imageElement.style.position = 'relative';
    imageElement.appendChild(rewrapBadge);
  }

  // Initialize the observer
  let rewrapBadgeObserverAttached = false;
  function initRewrapBadgeObserver() {
    // initRewrapBadgeObserver runs on DOMContentLoaded, immediately, and after a
    // 1s delay to catch late content; guard so we only ever attach one observer.
    if (rewrapBadgeObserverAttached) return;
    const appContentContainer = document.querySelector('.r-app-content-loaded');

    if (appContentContainer) {
      rewrapBadgeObserverAttached = true;
      // Coalesce mutation bursts into a single addRewrapBadges() run per frame.
      let addBadgesQueued = false;
      const runAddBadges = () => {
        if (addBadgesQueued) return;
        addBadgesQueued = true;
        requestAnimationFrame(() => {
          addBadgesQueued = false;
          addRewrapBadges();
        });
      };
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            runAddBadges();
            break;
          }
        }
      });

      // Start observing
      observer.observe(appContentContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
      
      // Also check immediately in case content is already loaded
      setTimeout(() => {
        addRewrapBadges();
      }, 100);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRewrapBadgeObserver);
  } else {
    initRewrapBadgeObserver();
  }

  // Also initialize after a delay to catch any late-loading content
  setTimeout(initRewrapBadgeObserver, 1000);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

(function() {
  /*
    Data Layer Push for Country Variable
    Pushes the country value from window.Shopify.country to the data layer
  */

  document.addEventListener('DOMContentLoaded', function() {
    window.dataLayer = window.dataLayer || [];

    var country = window.Shopify && window.Shopify.country ? window.Shopify.country : null;
    if (country) {
      window.dataLayer.push({
        'event': 'DL - WKND Tag',
        'country': country
      })
    } else {
      console.warn('Shopify country not found');
    }
  });
})();

(function() {
  if (!document.body.classList.contains('template-product')) return;

  // When the Yotpo write-a-review CTA is clicked inside a product-modal, close the
  // product-modal so only the Yotpo modal is visible (prevents modal stacking).
  document.addEventListener('click', function(e) {
    if (!e.target.closest('#yotpo-main-widget-btn')) return;
    var openModal = document.querySelector('dialog.product-modal:not([inert])');
    if (openModal) {
      openModal.close();
    }
  });
})();

// ── Carousel (grid-slider) helpers ──────────────────────────────────────────
// The quick-add QV carousel uses the theme's native <grid-slider> element
// (native scroll + desktop drag/arrows) instead of Flickity. The carousel
// markup is injected while the modal is inert/hidden, so we (re)dispatch the
// grid-slider init hook once it is visible and its dimensions are known.
function rsInitCarousel(carousel) {
  if (!carousel) return;
  var gridSlider = carousel.closest('grid-slider');
  if (!gridSlider) return;
  gridSlider.dispatchEvent(new CustomEvent('theme:grid-slider:init', { bubbles: true }));
}

function rsResetCarousel(carousel) {
  if (!carousel) return;
  carousel.scrollLeft = 0;
}

document.addEventListener('theme:quick-add:open', function () {
  var openModal = document.querySelector('[data-quick-add-modal][open]');
  if (openModal) rsPreloadQvSwatches(openModal);
  document.querySelectorAll('[data-quick-add-modal][open] [data-rs-qv-carousel]').forEach(rsInitCarousel);
});

function rsPreloadQvSwatches(panel) {
  panel.querySelectorAll('.rs-qv-panel__colors').forEach(function (colorsEl) {
    var swatchesEl = colorsEl.querySelector('.rs-qv-panel__swatches');
    if (!swatchesEl) return;

    var swatchBtns = swatchesEl.querySelectorAll('.rs-qv-panel__swatch');
    if (!swatchBtns.length) return;

    // Inject a shimmer row matching the real swatch count.
    var skeleton = document.createElement('div');
    skeleton.className = 'rs-qv-swatches-skeleton';
    swatchBtns.forEach(function () {
      var item = document.createElement('span');
      item.className = 'rs-qv-swatches-skeleton__item';
      skeleton.appendChild(item);
    });
    colorsEl.classList.add('rs-qv-colors--loading');
    colorsEl.appendChild(skeleton);

    function removeSkeleton() {
      skeleton.remove();
      colorsEl.classList.remove('rs-qv-colors--loading');
    }

    // For image-based swatches wait for the images; otherwise one rAF is enough.
    var srcs = [];
    swatchBtns.forEach(function (btn) {
      var match = (btn.getAttribute('style') || '').match(/--swatch:\s*url\((['"]?)([^'")]+)\1\)/);
      if (!match) return;
      var probe = new Image();
      probe.src = match[2];
      if (!probe.complete) srcs.push(match[2]);
    });

    if (!srcs.length) {
      requestAnimationFrame(removeSkeleton);
      return;
    }

    var pending = srcs.length;
    srcs.forEach(function (src) {
      var img = new Image();
      img.onload = img.onerror = function () { if (--pending <= 0) removeSkeleton(); };
      img.src = src;
    });
  });
}

// ── Quick View inline panel ────────────────────────────────────────────
(function () {
  // The DraggableSlider calls e.preventDefault() on mousedown at the slider
  // container level, which suppresses click events on everything inside it.
  // Intercept in capture phase so the slider never sees mousedowns from within
  // the QV panel, restoring normal click behaviour for buttons inside the panel.
  document.addEventListener('mousedown', function (e) {
    if (e.target.closest('[data-rs-qv-panel]')) {
      e.stopPropagation();
    }
  }, true);
  function replaceCardSlider(gridItem, images) {
    if (!gridItem || !images || !images.length) return;
    var toShow = images.slice(0, 5);
    function swapImg(el, src) {
      if (!el) return;
      el.removeAttribute('srcset');
      el.src = src;
      var pic = el.closest('picture');
      if (pic) pic.querySelectorAll('source').forEach(function (s) { s.removeAttribute('srcset'); });
    }
    swapImg(gridItem.querySelector('[data-product-image-default] img'), toShow[0]);
    var slider = gridItem.querySelector('[data-hover-slider]');
    if (!slider) return;
    var slides = Array.from(slider.querySelectorAll('.product-item__bg__slide'));
    slides.forEach(function (slide, i) {
      if (i < toShow.length) swapImg(slide.querySelector('img'), toShow[i]);
    });
  }

  function openPanel(gridItem) {
    const myPanel = gridItem.querySelector('[data-rs-qv-panel]');
    document.querySelectorAll('[data-rs-qv-panel]:not([hidden])').forEach(function (p) {
      if (p !== myPanel) closePanel(p);
    });
    if (!myPanel) return;
    myPanel.removeAttribute('hidden');
    rsPreloadQvSwatches(myPanel);
  }

  function closePanel(panel) {
    panel.setAttribute('hidden', '');
    panel._rvActiveVariants = null;
  }

  function getSelectedOptions(panel) {
    const opts = {};
    // Size
    panel.querySelectorAll('.rs-qv-panel__size.is-active').forEach(function (btn) {
      opts[btn.dataset.optionPosition] = btn.dataset.rsQvSize;
    });
    // In-product colour variant
    panel.querySelectorAll('.rs-qv-panel__swatch.is-active[data-rs-qv-color]').forEach(function (btn) {
      opts[btn.dataset.optionPosition] = btn.dataset.rsQvColor;
    });
    return opts;
  }

  function swapCardImage(panel, imgUrl) {
    if (!imgUrl) return;
    const mainSlide = panel.querySelector('[data-rs-qv-main-image] img');
    if (mainSlide) {
      mainSlide.removeAttribute('srcset');
      mainSlide.src = imgUrl;
      const pic = mainSlide.closest('picture');
      if (pic) pic.querySelectorAll('source').forEach(function (s) { s.removeAttribute('srcset'); });
    }
    const carousel = panel.querySelector('[data-rs-qv-carousel]');
    if (carousel) rsResetCarousel(carousel);
    const gridItem = panel.closest('[data-grid-item]');
    if (!gridItem) return;
    const img = gridItem.querySelector('[data-product-image-default] img');
    if (img) {
      img.removeAttribute('srcset');
      img.src = imgUrl;
      const picture = img.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach(function (s) { s.removeAttribute('srcset'); });
      }
    }
  }

  function findVariant(variants, selected) {
    return variants.find(function (v) {
      return Object.keys(selected).every(function (pos) {
        return v['option' + pos] === selected[pos];
      });
    }) || null;
  }

  function findVariantBySize(variants, sizeValue) {
    if (!sizeValue) return variants[0] || null;
    return variants.find(function (v) {
      return v.option1 === sizeValue || v.option2 === sizeValue || v.option3 === sizeValue;
    }) || variants[0] || null;
  }

  function updateQvSizeAvailability(panel, variants) {
    panel.querySelectorAll('[data-rs-qv-size]').forEach(function (btn) {
      var sizeVal = btn.dataset.rsQvSize;
      if (sizeVal == null) return;
      var lower = sizeVal.toLowerCase();
      // Match the size value against ANY option position. The size can live in
      // option1/2/3 depending on the product's option order (DVF products are
      // Style/Color/Size, so size is option3), and Nosto-rendered panels emit a
      // hardcoded data-option-position="1". Trusting that position matched size
      // against option1 (the Style code), found nothing, and marked every size
      // unavailable on a colour switch. Mirrors findVariantBySize / the Nosto
      // template's applyVariantAvailability, and treats a size as available when
      // SOME matching variant is in stock.
      var avail = variants.some(function (v) {
        var eq = function (o) { return o != null && (o === sizeVal || o.toLowerCase() === lower); };
        return (eq(v.option1) || eq(v.option2) || eq(v.option3)) && v.available;
      });
      btn.classList.toggle('is-unavailable', !avail);
    });
  }

  function updateVariantState(panel, variant) {
    const input = panel.querySelector('[data-rs-qv-variant-id]');
    const atcBtn = panel.querySelector('[data-rs-qv-atc]');
    if (!variant) return;
    if (input) input.value = variant.id;
    if (atcBtn) {
      const textSpan = atcBtn.querySelector('.btn__text');
      atcBtn.disabled = !variant.available;
      if (textSpan) {
        textSpan.textContent = variant.available
          ? (atcBtn.dataset.labelAdd || textSpan.textContent)
          : (atcBtn.dataset.labelSoldOut || 'Sold Out');
      }
    }
  }

  // Cache "Add to Bag" label from initial render
  document.querySelectorAll('[data-rs-qv-atc]').forEach(function (btn) {
    const textSpan = btn.querySelector('.btn__text');
    btn.dataset.labelAdd = textSpan ? textSpan.textContent.trim() : btn.textContent.trim();
  });

  document.addEventListener('click', function (e) {
    // Open
    const openBtn = e.target.closest('[data-rs-qv-btn]');
    if (openBtn) {
      e.preventDefault();
      const gridItem = openBtn.closest('[data-grid-item]');
      if (gridItem) openPanel(gridItem);
      return;
    }

    // Close
    const closeBtn = e.target.closest('[data-rs-qv-close]');
    if (closeBtn) {
      const panel = closeBtn.closest('[data-rs-qv-panel]');
      if (panel) closePanel(panel);
      return;
    }

    // Size selection
    const sizeBtn = e.target.closest('[data-rs-qv-size]');
    if (sizeBtn) {
      const panel = sizeBtn.closest('[data-rs-qv-panel]');
      if (!panel) return;
      const pos = sizeBtn.dataset.optionPosition;
      panel.querySelectorAll('[data-rs-qv-size][data-option-position="' + pos + '"]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      sizeBtn.classList.add('is-active');
      try {
        if (panel._rvActiveVariants) {
          const variant = findVariantBySize(panel._rvActiveVariants, sizeBtn.dataset.rsQvSize);
          updateVariantState(panel, variant);
        } else {
          const variants = JSON.parse(panel.querySelector('.rs-qv-variants').textContent);
          const variant = findVariant(variants, getSelectedOptions(panel));
          updateVariantState(panel, variant);
        }
      } catch (_) {}
      return;
    }

    // In-product colour variant swatch
    const colorBtn = e.target.closest('[data-rs-qv-color]');
    if (colorBtn) {
      const panel = colorBtn.closest('[data-rs-qv-panel]');
      if (!panel) return;
      const pos = colorBtn.dataset.optionPosition;
      panel.querySelectorAll('[data-rs-qv-color][data-option-position="' + pos + '"]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      colorBtn.classList.add('is-active');
      // Update colour label
      const colorLabel = panel.querySelector('[data-rs-qv-color-name]');
      if (colorLabel) colorLabel.textContent = colorBtn.dataset.rsQvColor;
      // Swap card image
      swapCardImage(panel, colorBtn.dataset.rsQvImage);
      // Sync MC swatches active state
      const colorGridItem = panel.closest('[data-grid-item]');
      const colorMcTrigger = colorGridItem && colorGridItem.querySelector('.mc-swatches-trigger');
      if (colorMcTrigger) {
        const colorValLc = (colorBtn.dataset.rsQvColor || '').toLowerCase();
        colorMcTrigger.querySelectorAll('[data-mc-image]').forEach(function (b) {
          b.classList.toggle('is-active', (b.dataset.mcColor || '').toLowerCase() === colorValLc);
        });
      }
      // Update variant
      try {
        const variants = JSON.parse(panel.querySelector('.rs-qv-variants').textContent);
        const variant = findVariant(variants, getSelectedOptions(panel));
        updateVariantState(panel, variant);
      } catch (_) {}
      return;
    }

    // Sibling product colour swatch
    const sibBtn = e.target.closest('[data-rs-qv-sibling-swatch]');
    if (sibBtn) {
      const panel = sibBtn.closest('[data-rs-qv-panel]');
      if (!panel) return;
      panel.querySelectorAll('[data-rs-qv-sibling-swatch]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      sibBtn.classList.add('is-active');
      const colorLabel = panel.querySelector('[data-rs-qv-color-name]');
      if (colorLabel) colorLabel.textContent = sibBtn.dataset.rsQvSiblingColor;

      // Swap main card image immediately from server-rendered URL
      if (sibBtn.dataset.rsQvSiblingImage) {
        swapCardImage(panel, sibBtn.dataset.rsQvSiblingImage);
      }

      const gridItem = panel.closest('[data-grid-item]');

      // Sync MC swatches active state to match selected sibling color
      const mcTrigger = gridItem && gridItem.querySelector('.mc-swatches-trigger');
      if (mcTrigger) {
        const sibColorLc = (sibBtn.dataset.rsQvSiblingColor || '').toLowerCase();
        mcTrigger.querySelectorAll('[data-mc-image]').forEach(function (b) {
          b.classList.toggle('is-active', (b.dataset.mcColor || '').toLowerCase() === sibColorLc);
        });
      }

      function applyVariants(variants) {
        if (!variants || !variants.length) return;
        panel._rvActiveVariants = variants;
        updateQvSizeAvailability(panel, variants);
        const activeSizeBtn = panel.querySelector('[data-rs-qv-size].is-active');
        const sizeVal = activeSizeBtn ? activeSizeBtn.dataset.rsQvSize : null;
        const variant = findVariantBySize(variants, sizeVal);
        if (variant) updateVariantState(panel, variant);
      }

      // Pre-populate from embedded JSON (same as upsell-panel handler) so variants
      // are available synchronously on the first click — no async window where
      // _rvActiveVariants is null and the wrong variant gets submitted.
      if (!sibBtn._rvProductData && sibBtn.dataset.rsVariants) {
        try { sibBtn._rvProductData = { variants: JSON.parse(sibBtn.dataset.rsVariants) }; } catch (_) {}
      }

      const sibUrl = sibBtn.dataset.rsQvSiblingSwatch;
      if (sibBtn._rvProductData && sibBtn._rvProductData.images) {
        // Full product data cached (from a previous fetch) — use immediately
        replaceCardSlider(gridItem, sibBtn._rvProductData.images);
        applyVariants(sibBtn._rvProductData.variants);
      } else {
        // Variants available (from pre-rendered JSON or prior fetch) — apply now;
        // fetch full product data in background only for image updates.
        if (sibBtn._rvProductData) applyVariants(sibBtn._rvProductData.variants);
        if (sibUrl) {
          var handle = sibUrl.replace(/.*\/products\//, '').split('?')[0];
          var hadVariants = !!sibBtn._rvProductData;
          fetch('/products/' + handle + '.js')
            .then(function (r) { return r.json(); })
            .then(function (p) {
              sibBtn._rvProductData = p;
              replaceCardSlider(gridItem, p.images);
              if (!hadVariants) applyVariants(p.variants);
            })
            .catch(function () {});
        }
      }
      return;
    }
  });

  // ATC form submit
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-rs-qv-panel] form');
    if (!form) return;
    e.preventDefault();

    const atcBtn = form.querySelector('[data-rs-qv-atc]');
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.classList.add('is-loading');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed');
        return res.json();
      })
      .then(function () {
        if (atcBtn) {
          atcBtn.classList.remove('is-loading');
          atcBtn.classList.add('is-added');
        }

        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        setTimeout(function () {
          const panel = form.closest('[data-rs-qv-panel]');
          if (panel) closePanel(panel);
          if (atcBtn) {
            atcBtn.classList.remove('is-added');
            atcBtn.disabled = false;
          }
        }, 1200);
      })
      .catch(function () {
        if (atcBtn) {
          atcBtn.classList.remove('is-loading');
          atcBtn.disabled = false;
        }
      });
  });
})();

// ── Upsell panel colour swatches ─────────────────────────────────────────────
(function () {
  function swapUpsellImage(panel, imgUrl) {
    if (!imgUrl) return;
    var img = panel.querySelector('[data-rs-qv-main-image] img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = imgUrl;
    var picture = img.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (s) { s.removeAttribute('srcset'); });
    }
    var carousel = panel.querySelector('[data-rs-qv-carousel]');
    if (carousel) rsResetCarousel(carousel);
  }

  function replaceCarouselImages(carousel, images) {
    if (!carousel || !images || !images.length) return;
    var toShow = images.slice(0, 5);
    carousel.innerHTML = '';
    toShow.forEach(function (src, i) {
      var slide = document.createElement('div');
      slide.className = 'rs-qv-panel__carousel-slide rs-qv-panel__carousel-slide--loading';
      slide.setAttribute('data-grid-item', '');
      if (i === 0) slide.setAttribute('data-rs-qv-main-image', '');
      var img = document.createElement('img');
      img.alt = '';
      img.loading = i === 0 ? 'eager' : 'lazy';
      var done = function () { slide.classList.remove('rs-qv-panel__carousel-slide--loading'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      img.src = src;
      slide.appendChild(img);
      carousel.appendChild(slide);
    });
    rsResetCarousel(carousel);
    rsInitCarousel(carousel);
  }

  // Read the currently selected option values from the panel
  function getSelectedValues(panel) {
    var vals = [];

    function push(v) {
      v = (v || '').toLowerCase();
      if (v && vals.indexOf(v) === -1) vals.push(v);
    }

    // 1. [data-option-value] spans — Broadcast keeps these updated on variant change
    panel.querySelectorAll('[data-option-value]').forEach(function (el) {
      push(el.textContent.trim());
    });

    // 2. Always also check [data-single-option-selector] inputs — do NOT skip when method 1
    //    found values, because method 1 may only surface some options (e.g. style code +
    //    color) while size lives in a popout hidden input that has no [data-option-value] span.
    panel.querySelectorAll('[data-single-option-selector]').forEach(function (input) {
      if (input.type === 'hidden' && input.value) {
        push(input.value);
      } else if (input.type === 'radio' && input.checked && input.value) {
        push(input.value);
      }
    });

    // 3. Fallback: input[name="id"] + product JSON.
    //    [data-product-json] lives outside [data-rs-upsell-panel] so search upward.
    if (!vals.length) {
      var idInput = panel.querySelector('input[name="id"]');
      var scope = panel.closest('[data-api-content]') || panel.parentElement;
      var jsonScript = scope ? scope.querySelector('[data-product-json]') : null;
      if (idInput && jsonScript) {
        try {
          var pd = JSON.parse(jsonScript.textContent);
          var cur = pd.variants.find(function (v) { return String(v.id) === String(idInput.value); });
          if (cur) {
            [cur.option1, cur.option2, cur.option3].filter(Boolean).forEach(function (o) { push(o); });
          }
        } catch (_) {}
      }
    }

    return vals;
  }

  function findSiblingVariant(sibVariants, panel) {
    var selectedVals = getSelectedValues(panel);

    if (!selectedVals.length) {
      var fallback = sibVariants.find(function (v) { return v.available; }) || sibVariants[0] || null;
      return fallback;
    }

    var match = sibVariants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3].filter(Boolean).map(function (o) { return o.toLowerCase(); });
      return selectedVals.some(function (val) { return opts.indexOf(val) !== -1; }) && v.available;
    });
    if (match) {
      return match;
    }

    match = sibVariants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3].filter(Boolean).map(function (o) { return o.toLowerCase(); });
      return selectedVals.some(function (val) { return opts.indexOf(val) !== -1; });
    });
    var result = match || sibVariants.find(function (v) { return v.available; }) || sibVariants[0] || null;
    return result;
  }

  // Mirror Broadcast's SelloutVariants logic using the sibling's variant data so the size
  // selector shows strikethrough/sold-out for unavailable sizes in the selected sibling.
  function updateOptionAvailability(panel, sibVariants) {
    // Radio inputs (size shown as radio buttons)
    panel.querySelectorAll('[data-option-position] input[data-single-option-selector][type="radio"]').forEach(function (input) {
      var posEl = input.closest('[data-option-position]');
      if (!posEl) return;
      var pos = parseInt(posEl.dataset.optionPosition, 10); // 1-based
      var key = 'option' + pos;
      var val = input.value;
      input.classList.remove('sold-out', 'unavailable');
      var found = sibVariants.find(function (v) { return v[key] === val; });
      if (!found) {
        input.classList.add('unavailable');
      } else if (!found.available) {
        input.classList.add('sold-out');
      }
    });

    // Popout options (size shown as a select-popout dropdown)
    panel.querySelectorAll('[data-option-position] [data-popout-option]').forEach(function (opt) {
      var posEl = opt.closest('[data-option-position]');
      if (!posEl) return;
      var pos = parseInt(posEl.dataset.optionPosition, 10);
      var key = 'option' + pos;
      var val = opt.dataset.value;
      opt.classList.remove('sold-out', 'unavailable');
      var found = sibVariants.find(function (v) { return v[key] === val; });
      if (!found) {
        opt.classList.add('unavailable');
      } else if (!found.available) {
        opt.classList.add('sold-out');
      }
    });
  }

  function resolveSiblingVariant(panel) {
    var sibBtn = panel._rvActiveSiblingBtn;
    if (!sibBtn || !sibBtn._rvProductData) {
      return;
    }
    var v = findSiblingVariant(sibBtn._rvProductData.variants, panel);
    panel._rvSiblingVariantId = v ? v.id : null;
  }

  function atcVariant(variantId, btn) {
    if (!variantId) return;
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); }
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        setTimeout(function () {
          if (btn) { btn.classList.remove('is-added'); btn.disabled = false; }
        }, 1200);
      })
      .catch(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      });
  }

  // Faithful port of Broadcast's formatMoney (theme.js is not exposed globally).
  // Sibling variant prices come from product JSON in cents and must render with the
  // store's money format, matching the server-rendered price exactly.
  function rsFormatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
    function formatWithDelimiters(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return '0';
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = formatString.match(placeholderRegex);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_period_and_space_separator': value = formatWithDelimiters(cents, 2, ' ', '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  // Mirror Broadcast's updateProductPrices for the selected sibling variant. The sibling
  // swatches are plain buttons (not Broadcast's native option radios), so the native
  // product-form never recomputes the price when the colour changes — update it here.
  function updateUpsellPrice(panel, variant) {
    var wrap = panel.querySelector('[data-price-wrapper]');
    if (!wrap) return;
    var priceEl = wrap.querySelector('[data-product-price]');
    if (!priceEl) return;
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    priceEl.innerHTML = variant.price === 0
      ? ((window.theme && window.theme.strings && window.theme.strings.free) || 'Free')
      : rsFormatMoney(variant.price, format);
    priceEl.classList.toggle('product__price--sale', !!onSale);
    var compareEl = wrap.querySelector('[data-compare-price]');
    if (compareEl) {
      compareEl.innerHTML = onSale ? rsFormatMoney(variant.compare_at_price, format) : '';
      compareEl.classList.toggle('hidden', !onSale);
    }
    var compareText = wrap.querySelector('[data-compare-text]');
    if (compareText) compareText.classList.toggle('hidden', !onSale);
  }

  function updateUpsellAtcState(panel) {
    var sibBtn = panel._rvActiveSiblingBtn;
    if (!sibBtn || !sibBtn._rvProductData || !panel._rvSiblingVariantId) return;
    var variant = sibBtn._rvProductData.variants.find(function (v) { return v.id === panel._rvSiblingVariantId; });
    if (!variant) return;
    updateUpsellPrice(panel, variant);
    var atcBtn = panel.querySelector('[data-add-to-cart]');
    if (!atcBtn) return;
    var textEl = atcBtn.querySelector('[data-add-to-cart-text]');
    atcBtn.disabled = !variant.available;
    if (textEl) {
      textEl.textContent = variant.available
        ? (window.theme && window.theme.strings && window.theme.strings.addToCart) || 'Add to Bag'
        : (window.theme && window.theme.strings && window.theme.strings.soldOut) || 'Sold Out';
    }
  }

  document.addEventListener('click', function (e) {
    // Sibling colour swatch — resolve variant synchronously from pre-rendered data
    var sibBtn = e.target.closest('[data-rs-upsell-panel] [data-rs-qv-sibling-swatch]');
    if (sibBtn) {
      var panel = sibBtn.closest('[data-rs-upsell-panel]');
      panel.querySelectorAll('[data-rs-qv-sibling-swatch]').forEach(function (b) { b.classList.remove('is-active'); });
      sibBtn.classList.add('is-active');
      panel._rvSiblingVariantId = null;
      panel._rvActiveSiblingBtn = sibBtn;
      var colorLabel = panel.querySelector('[data-rs-qv-color-name]');
      if (colorLabel) colorLabel.textContent = sibBtn.dataset.rsQvSiblingColor;
      swapUpsellImage(panel, sibBtn.dataset.rsQvSiblingImage);

      if (!sibBtn._rvProductData && sibBtn.dataset.rsVariants) {
        try { sibBtn._rvProductData = { variants: JSON.parse(sibBtn.dataset.rsVariants) }; } catch (_) {}
      }

      var carousel = panel.querySelector('[data-rs-qv-carousel]');

      if (sibBtn._rvProductData && sibBtn._rvProductData.images) {
        // Full product data cached from a previous fetch — use it immediately
        resolveSiblingVariant(panel);
        updateUpsellAtcState(panel);
        updateOptionAvailability(panel, sibBtn._rvProductData.variants);
        replaceCarouselImages(carousel, sibBtn._rvProductData.images);
      } else {
        // Resolve variants from pre-rendered data if available, then fetch for images
        if (sibBtn._rvProductData) {
          resolveSiblingVariant(panel);
          updateUpsellAtcState(panel);
          updateOptionAvailability(panel, sibBtn._rvProductData.variants);
        }
        var sibUrl = sibBtn.dataset.rsQvSiblingSwatch;
        if (sibUrl) {
          var handle = sibUrl.replace(/.*\/products\//, '').split('?')[0];
          var hadVariants = !!sibBtn._rvProductData;
          fetch('/products/' + handle + '.js')
            .then(function (r) { return r.json(); })
            .then(function (p) {
              sibBtn._rvProductData = p;
              if (!hadVariants) {
                resolveSiblingVariant(panel);
                updateUpsellAtcState(panel);
                updateOptionAvailability(panel, p.variants);
              }
              replaceCarouselImages(carousel, p.images);
            })
            .catch(function () {});
        }
      }
      return;
    }

    // In-product colour swatch — compute variant directly, update input, then click radio
    var colorBtn = e.target.closest('[data-rs-upsell-panel] [data-rs-qv-color]');
    if (colorBtn) {
      var panel = colorBtn.closest('[data-rs-upsell-panel]');
      panel._rvSiblingVariantId = null;
      panel._rvActiveSiblingBtn = null;
      var pos = colorBtn.dataset.optionPosition;
      panel.querySelectorAll('[data-rs-qv-color][data-option-position="' + pos + '"]').forEach(function (b) { b.classList.remove('is-active'); });
      colorBtn.classList.add('is-active');
      var colorLabel = panel.querySelector('[data-rs-qv-color-name]');
      if (colorLabel) colorLabel.textContent = colorBtn.dataset.rsQvColor;
      swapUpsellImage(panel, colorBtn.dataset.rsQvImage);

      // Compute the correct variant from product JSON and update input[name="id"] directly
      var jsonScript = panel.querySelector('[data-product-json]');
      if (jsonScript) {
        try {
          var pd = JSON.parse(jsonScript.textContent);
          // Collect current checked options, override the colour position
          var opts = {};
          panel.querySelectorAll('[data-option-position] input[type="radio"]:checked').forEach(function (r) {
            var wp = r.closest('[data-option-position]');
            if (wp) opts[wp.dataset.optionPosition] = r.value;
          });
          opts[pos] = colorBtn.dataset.rsQvColor;
          var variant = pd.variants.find(function (v) {
            return Object.keys(opts).every(function (p) { return v['option' + p] === opts[p]; });
          });
          if (variant) {
            var idInput = panel.querySelector('input[name="id"]');
            if (idInput) idInput.value = variant.id;
          }
        } catch (_) {}
      }

      // Also trigger the radio so Broadcast's UI state stays consistent
      var wrapper = panel.querySelector('[data-option-position="' + pos + '"]');
      if (wrapper) {
        var radio = wrapper.querySelector('input[value="' + colorBtn.dataset.rsQvColor + '"]');
        if (radio && !radio.checked) radio.click();
      }
      return;
    }
  });

  // Re-resolve sibling variant when user changes size after selecting a sibling colour
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-rs-upsell-panel] [data-option-position] input[type="radio"]');
    if (!radio) return;
    var panel = radio.closest('[data-rs-upsell-panel]');
    if (!panel || !panel._rvActiveSiblingBtn) return;
    resolveSiblingVariant(panel);
    updateUpsellAtcState(panel);
  });

  // Intercept ATC button click in capture phase — Broadcast handles ATC via click, not submit,
  // so we must intercept click before Broadcast's bubble-phase listener sees it.
  document.addEventListener('click', function (e) {
    var atcBtn = e.target.closest('[data-rs-upsell-panel] [data-add-to-cart]');
    if (!atcBtn) return;
    var panel = atcBtn.closest('[data-rs-upsell-panel]');
    if (!panel || !panel._rvActiveSiblingBtn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    resolveSiblingVariant(panel);
    if (!panel._rvSiblingVariantId) return;
    atcVariant(panel._rvSiblingVariantId, atcBtn);
  }, true);
}());

// ── More Colors hover swatches ─────────────────────────────────────────
(function () {
  // Fetch swatch image URLs from api-product-upsell on first hover when data-mc-image is empty.
  // This bypasses the all_products 20-handle-per-render limit that empties the Liquid-rendered URLs.
  document.addEventListener('mouseover', function (e) {
    if (!(e.target instanceof Element)) return;
    var trigger = e.target.closest('.mc-swatches-trigger');
    if (!trigger || trigger._mcImagesFetched) return;

    var emptySwatches = Array.from(trigger.querySelectorAll('[data-mc-image]')).filter(function (b) {
      return !b.dataset.mcImage;
    });
    if (!emptySwatches.length) return;
    trigger._mcImagesFetched = true;

    var gridItem = trigger.closest('[data-grid-item]');
    if (!gridItem) return;
    var productLinkEl = gridItem.querySelector('[data-product-link]');
    var productUrl = productLinkEl ? productLinkEl.getAttribute('data-product-link') : null;
    if (!productUrl) return;

    trigger._mcFetchPromise = fetch(productUrl + '?section_id=api-product-upsell')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetched = Array.from(doc.querySelectorAll('[data-rs-qv-sibling-swatch]'));
        if (!fetched.length) fetched = Array.from(doc.querySelectorAll('[data-rs-qv-color]'));

        emptySwatches.forEach(function (btn) {
          var color = (btn.dataset.mcColor || '').toLowerCase();
          var match = fetched.find(function (fb) {
            return ((fb.dataset.rsQvSiblingColor || fb.dataset.rsQvColor || '').toLowerCase() === color);
          });
          if (!match) return;
          var imgUrl = match.dataset.rsQvSiblingImage || match.dataset.rsQvImage || '';
          if (imgUrl) btn.dataset.mcImage = imgUrl;
        });
        emptySwatches.forEach(function (btn) { btn.classList.remove('is-loading'); });
        trigger._mcFetchPromise = null;
      })
      .catch(function (err) {
        console.warn('[MC swatches] fetch failed for', productUrl, err);
        trigger._mcImagesFetched = false;
        trigger._mcFetchPromise = null;
        emptySwatches.forEach(function (btn) { btn.classList.remove('is-loading'); });
      });
  }, true);

  // Toggle MC panel on click of "More Colors" text — all devices use JS, not CSS hover.
  document.addEventListener('click', function (e) {
    var moreColors = e.target.closest('.product-item__more-colors');
    if (!moreColors) return;
    var trigger = moreColors.closest('.mc-swatches-trigger');
    if (!trigger) return;
    e.preventDefault();
    document.querySelectorAll('.mc-swatches-trigger.is-open').forEach(function (t) {
      if (t !== trigger) t.classList.remove('is-open');
    });
    trigger.classList.toggle('is-open');

    // If we're opening and a fetch is still in flight, mark empty swatches as loading.
    if (trigger.classList.contains('is-open') && trigger._mcFetchPromise) {
      trigger.querySelectorAll('[data-mc-image]').forEach(function (btn) {
        if (!btn.dataset.mcImage) btn.classList.add('is-loading');
      });
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mc-image]');
    if (!btn) return;
    var gridItem = btn.closest('[data-grid-item]');
    if (!gridItem) return;

    // Update active state within the panel
    var panel = btn.closest('.mc-swatches-panel');
    if (panel) {
      panel.querySelectorAll('[data-mc-image]').forEach(function (b) { b.classList.remove('is-active'); });
    }
    btn.classList.add('is-active');

    // Sync the colour to the QV overlay by forwarding to its matching swatch — the
    // sibling handler does the full replaceCardSlider (all card images) + variant +
    // label sync. Route whether the overlay is open or closed so every card image
    // (main + hover slider) mirrors the selected colour and the overlay reflects it
    // when later opened. When closed we only route for Liquid cards (they carry the
    // hover slider); .ns-product (Preact) cards drive their own images, so we leave
    // their closed state alone.
    var qvPanel = gridItem.querySelector('[data-rs-qv-panel]:not([hidden])')
      || (gridItem.querySelector('[data-hover-slider]') ? gridItem.querySelector('[data-rs-qv-panel]') : null);
    if (qvPanel) {
      var mcColor = (btn.dataset.mcColor || '').toLowerCase();
      var matchSib = Array.from(qvPanel.querySelectorAll('[data-rs-qv-sibling-swatch]')).find(function (s) {
        return (s.dataset.rsQvSiblingColor || '').toLowerCase() === mcColor;
      });
      if (matchSib && !matchSib.classList.contains('is-active')) {
        matchSib.click();
      } else if (!matchSib) {
        var matchColorSwatch = Array.from(qvPanel.querySelectorAll('[data-rs-qv-color]')).find(function (s) {
          return (s.dataset.rsQvColor || '').toLowerCase() === mcColor;
        });
        if (matchColorSwatch && !matchColorSwatch.classList.contains('is-active')) matchColorSwatch.click();
      }
    }

    // Swap the grid card image
    var imgUrl = btn.dataset.mcImage;
    if (!imgUrl) return;
    var img = gridItem.querySelector('[data-product-image-default] img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = imgUrl;
    var picture = img.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (s) { s.removeAttribute('srcset'); });
    }
  });

  // Mobile quick add close button — the theme binds its listener to the first
  // [data-quick-add-modal-close] found in the modal (the static template button we hid),
  // so our button needs its own handler. Programmatically clicking the native hidden
  // button is the most reliable path: it always has the theme's listener attached.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rs-qv-panel__close');
    if (!btn) return;
    var modal = btn.closest('[data-quick-add-modal]');
    if (!modal) return;
    var nativeClose = modal.querySelector('.product-quick-add__close-outer [data-quick-add-modal-close]');
    if (nativeClose) {
      nativeClose.click();
    } else {
      modal.dispatchEvent(new CustomEvent('theme:modal:close', { bubbles: false }));
    }
  });

  // Coalesce bursts of MutationObserver callbacks into a single run per animation
  // frame. Nosto (category grid, filtering, infinite scroll) injects hundreds of
  // nodes at once; without this, a body-level observer callback fires once per
  // inserted node and tanks scroll/interaction performance on collection pages.
  function rafDebounce(fn) {
    var queued = false;
    return function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        fn();
      });
    };
  }

  // Compact product cards in Nosto cart recs (recently viewed + frequently bought together).
  //
  // Nosto renders product cards into #cartpage-nosto-1 / #cartpage-nosto-2 via its
  // dashboard templates. When those templates output standard theme HTML ([data-grid-item]),
  // we add product-item--compact and intercept any desktop QV button clicks to route
  // them to the mobile drawer trigger instead.
  (function () {
    var CART_REC_IDS = ['cartpage-nosto-1', 'cartpage-nosto-2'];

    function applyCompactCard(root) {
      root.querySelectorAll('[data-grid-item]').forEach(function (card) {
        if (card.classList.contains('product-item--compact')) return;
        card.classList.add('product-item--compact');

        // On desktop the theme's custom.js opens the inline QV panel on data-rs-qv-btn
        // click. Intercept that and click the mobile drawer trigger instead.
        var qvBtn = card.querySelector('[data-rs-qv-btn]');
        if (qvBtn) {
          qvBtn.addEventListener('click', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            var drawerBtn = card.querySelector('[data-quick-add-btn]');
            if (drawerBtn) drawerBtn.click();
          }, true);
        }
      });
    }

    function watchPlacement(id) {
      var el = document.getElementById(id);
      if (!el) return;
      // Apply to already-rendered cards (e.g. hot reload / cached Nosto output)
      applyCompactCard(el);
      // Watch for Nosto injecting cards after page load
      var observer = new MutationObserver(rafDebounce(function () {
        applyCompactCard(el);
      }));
      observer.observe(el, { childList: true, subtree: true });
    }

    // Nosto elements may not exist until the cart drawer is opened for the first time.
    // Observe the document body so we catch them whenever they're created.
    var placementsWatched = {};
    var bodyObserver = new MutationObserver(rafDebounce(function () {
      CART_REC_IDS.forEach(function (id) {
        if (!placementsWatched[id] && document.getElementById(id)) {
          placementsWatched[id] = true;
          watchPlacement(id);
        }
      });
      // Once every placement is wired up there is nothing left to detect.
      if (CART_REC_IDS.every(function (id) { return placementsWatched[id]; })) {
        bodyObserver.disconnect();
      }
    }));
    bodyObserver.observe(document.body, { childList: true, subtree: true });

    // Also try immediately in case elements are already in the DOM
    CART_REC_IDS.forEach(function (id) {
      if (document.getElementById(id)) {
        placementsWatched[id] = true;
        watchPlacement(id);
      }
    });
  }());

  // Inline QV panel for product-page Nosto recommendation placements.
  //
  // productpage-nosto-1/2/3 are standard Nosto recommendation placements whose
  // cards render via the vendor Nosto Preact template (.shopify/vendors/nosto/
  // Product.jsx). Those cards have only data-quick-add-btn (no data-rs-qv-btn /
  // data-rs-qv-panel), so clicking the "+" on desktop opens the full cart drawer
  // instead of the inline overlay used on collection-page Nosto cards.
  //
  // Fix: prefetch the Liquid product-grid-item section for each card (which
  // renders the full RS QV panel), inject it into the card, and intercept
  // desktop clicks on data-quick-add-btn to open the panel instead.
  (function () {
    var PRODUCT_REC_IDS = ['productpage-nosto-1', 'productpage-nosto-2', 'productpage-nosto-3', 'categorypage-nosto-1', 'categorypage-nosto-2'];
    var recSelector = PRODUCT_REC_IDS.map(function (id) { return '#' + id; }).join(', ');
    // Also covers Broadcast's recently-viewed sections on collection and other pages
    var CONTAINER_SELECTOR = recSelector + ', [data-recent-wrapper], [data-recently-viewed-wrapper]';

    function getNostoCard(el) {
      return el.closest('.ns-product') || el.closest('[data-grid-item]');
    }

    // openPanel lives in a sibling IIFE and is out of scope here. Replicate its
    // small open logic; the panel's own buttons (close/size/ATC) are handled by
    // document-level delegation, so they work regardless of who opened it.
    function openRsQvPanel(card) {
      var myPanel = card.querySelector('[data-rs-qv-panel]');
      if (!myPanel) return;
      // Cache "Add to Bag" label on first open — the static cache loop at page load
      // misses dynamically-injected panels, so labelAdd would be unset and
      // updateVariantState would incorrectly keep "Sold Out" when restoring an available variant.
      myPanel.querySelectorAll('[data-rs-qv-atc]').forEach(function (btn) {
        if (!btn.dataset.labelAdd) {
          var textSpan = btn.querySelector('.btn__text');
          btn.dataset.labelAdd = textSpan ? textSpan.textContent.trim() : btn.textContent.trim();
        }
      });
      document.querySelectorAll('[data-rs-qv-panel]:not([hidden])').forEach(function (p) {
        if (p !== myPanel) {
          p.setAttribute('hidden', '');
          p._rvActiveVariants = null;
        }
      });
      myPanel.removeAttribute('hidden');
      rsPreloadQvSwatches(myPanel);
    }

    // The "More Colors" trigger is part of the same product-grid-item markup, so we
    // extract it from the same fetch and drop it below the card info. All of its
    // interactions (toggle is-open, hover image fetch, swatch click → image swap)
    // are already handled by the document-level mc-swatches delegation elsewhere in
    // this file — the card already carries [data-product-link] and
    // [data-product-image-default] that those handlers need.
    function injectMoreColors(card, doc) {
      if (card.querySelector('.mc-swatches-trigger')) return;
      var mc = doc.querySelector('.mc-swatches-trigger');
      if (!mc) return;
      // Must live inside .product-item__info (where product-grid-item.liquid renders
      // it) so it inherits the left-aligned, body-small typography. Placing it as a
      // sibling of .product-information leaves it in the card's centered context.
      var info = card.querySelector('.product-item__info') || card.querySelector('.product-information');
      if (info) info.appendChild(mc);
      else card.appendChild(mc);
    }

    function injectQvPanel(card, handle, openOnDone) {
      if (card.querySelector('[data-rs-qv-panel]')) {
        if (openOnDone) openRsQvPanel(card);
        return;
      }
      // Store open intent before the in-flight guard so a click during prefetch
      // still opens the panel when the fetch completes.
      if (openOnDone) card.dataset.rsQvPdpOpen = '1';
      if (card.dataset.rsQvPdpFetching) return;
      card.dataset.rsQvPdpFetching = '1';
      fetch(window.theme.routes.root + 'products/' + handle + '?section_id=api-product-grid-item')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          delete card.dataset.rsQvPdpFetching;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          injectMoreColors(card, doc);
          var panel = doc.querySelector('[data-rs-qv-panel]');
          if (!panel) return;
          card.setAttribute('data-grid-item', '');
          card.appendChild(panel);
          if (card.dataset.rsQvPdpOpen) {
            delete card.dataset.rsQvPdpOpen;
            openRsQvPanel(card);
          }
        })
        .catch(function () { delete card.dataset.rsQvPdpFetching; });
    }

    function prefetchCard(card, handle) {
      if (card.dataset.rsQvPdpObserved) return;
      card.dataset.rsQvPdpObserved = '1';
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        injectQvPanel(card, handle, false);
      }, { rootMargin: '400px' });
      io.observe(card);
    }

    function getCardHandle(card) {
      var btn = card.querySelector('[data-quick-add-modal-handle]');
      return btn ? btn.dataset.quickAddModalHandle : null;
    }

    // Nosto renders these recommendation cards from an older product-grid-item
    // markup: a single data-quick-add-btn "Quick add" button (shown as the desktop
    // text bar), with no data-rs-qv-btn and no inline rs-qv-panel. We also match
    // data-rs-qv-btn in case a card ever renders the newer markup.
    var QV_TRIGGER_SELECTOR = '[data-quick-add-btn], [data-rs-qv-btn]';

    function processCards(container) {
      container.querySelectorAll(QV_TRIGGER_SELECTOR).forEach(function (btn) {
        var card = getNostoCard(btn);
        if (!card) return;
        var handle = getCardHandle(card);
        if (handle) prefetchCard(card, handle);
      });
    }

    // Intercept the desktop click in capture phase so we run before the Broadcast
    // quick-add handler (which opens the cart drawer) and before the existing
    // bubble-phase rs-qv delegation.
    document.addEventListener('click', function (e) {
      if (window.innerWidth < 750) return;
      var btn = e.target.closest(QV_TRIGGER_SELECTOR);
      if (!btn || !btn.closest(CONTAINER_SELECTOR)) return;
      var card = getNostoCard(btn);
      if (!card) return;
      var handle = getCardHandle(card);
      if (!handle) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      injectQvPanel(card, handle, true);
    }, true);

    function watchProductPlacement(id) {
      var el = document.getElementById(id);
      if (!el) return;
      processCards(el);
      var obs = new MutationObserver(rafDebounce(function () { processCards(el); }));
      obs.observe(el, { childList: true, subtree: true });
    }

    var pdpWatched = {};
    var pdpBodyObs = new MutationObserver(rafDebounce(function () {
      PRODUCT_REC_IDS.forEach(function (id) {
        if (!pdpWatched[id] && document.getElementById(id)) {
          pdpWatched[id] = true;
          watchProductPlacement(id);
        }
      });
      // Once every placement is wired up there is nothing left to detect.
      if (PRODUCT_REC_IDS.every(function (id) { return pdpWatched[id]; })) {
        pdpBodyObs.disconnect();
      }
    }));
    pdpBodyObs.observe(document.body, { childList: true, subtree: true });

    PRODUCT_REC_IDS.forEach(function (id) {
      if (document.getElementById(id)) {
        pdpWatched[id] = true;
        watchProductPlacement(id);
      }
    });

    // Watch Broadcast's recently-viewed sections (collection page footers, etc.)
    // Cards are populated asynchronously by Broadcast's recently-viewed JS, so we
    // observe the grid container for child additions.
    var rvWatched = [];
    function watchRecentlyViewedEl(container) {
      if (rvWatched.indexOf(container) !== -1) return;
      rvWatched.push(container);
      var grid = container.querySelector('[data-grid-slider]');
      if (grid) {
        processCards(grid);
        var obs = new MutationObserver(rafDebounce(function () { processCards(grid); }));
        obs.observe(grid, { childList: true, subtree: true });
      }
    }

    function checkRecentlyViewedContainers() {
      document.querySelectorAll('[data-recent-wrapper], [data-recently-viewed-wrapper]').forEach(watchRecentlyViewedEl);
    }

    checkRecentlyViewedContainers();
    var rvBodyObs = new MutationObserver(rafDebounce(checkRecentlyViewedContainers));
    rvBodyObs.observe(document.body, { childList: true, subtree: true });
  }());
}());
